import { FallbackImageWithoutRegExp } from '../model/fallback-image';
import { FALLBACK_IMAGES, DEFAULT_FALLBACK_IMAGE } from '../page-fallback.config';

export const getFallbackImage = (pathname: string): FallbackImageWithoutRegExp => {
    for (const fallbackImage of FALLBACK_IMAGES) {
        if (fallbackImage.regExp.test(pathname)) {
            return fallbackImage;
        }
    }

    return DEFAULT_FALLBACK_IMAGE;
};
